module.exports = __webpack_public_path__ + "static/top-95645d0657390a4b15cd4cdc2f7d831f.png";